import AppTheme from 'docs/src/modules/components/AppTheme';
import Terms from 'docs/src/pages/premium-themes/onepirate/Terms';

export default function Page() {
  return (
    <AppTheme title="Onepirate theme - MUI" description="A onepirate theme">
      <Terms />
    </AppTheme>
  );
}
